import { render, staticRenderFns } from "./PrepaymentInfo.vue?vue&type=template&id=2d681bae&"
import script from "./PrepaymentInfo.vue?vue&type=script&lang=js&"
export * from "./PrepaymentInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports